import Server from '@/service/server'

export default {
  namespaced: true,
  state: {
    sliders: [],
    collections: [],
    productDetails: [],
    searchProductResults: [],
    isLoadingCollections: false,
    genres: [],
    isLoadingGenres: false
  },
  getters: {
    sliders (state: any) {
      return state.sliders
        .filter((s: any) => s.state === 'Enable')
        .sort((s1: any, s2: any) => {
          return s1.order - s2.order
        })
    },
    collections (state: any) {
      return state.collections.filter((s: any) => s.state === 'Enable')
    },
    collection: (state: any) => (id: number) => {
      let collections = state.collections.filter((c: any) => {
        return c.id === id
      })

      if (collections.length === 0) return null
      return collections[0]
    },
    searchProductResults (state: any) {
      return state.searchProductResults
    },
    product: (state: any) => (id: number) => {
      let products = state.productDetails.filter((p: any) => p.id === id)

      if (products.length === 0) return null
      return products[0]
    },
    genres (state: any)
    {
      return state.genres.filter((s: any) =>  s.state === 'Enable')
    },
    genre: (state: any) => (id: number) => {
      let genres = state.genres.filter((g: any) => {
        return g.id === id
      })
      if(genres.length === 0) return null
      return genres[0]
    }
  },
  actions: {
    loadSliders (context: any) {
      const promise = Server.getSliders()
      promise.then((response: any) => {
        let result = response.body.result.items
        result = result.sort((s1: any, s2: any) => {
          return s2.order - s1.order
        })
        context.commit('slidersLoaded', result)
      })
      return promise
    },
    loadCollections (context: any) {
      if (context.state.isLoadingCollections) { return }

      context.commit('collectionLoading')

      const promise = Server.getCollections({ pageIndex: 1, pageCount: 100 })
      promise.then((response: any) => {
        let result = response.body.result.items
        result.forEach((item: any) => {
          item.products = []
          item.totalProductsCount = -1
        })
        context.commit('collectionsLoaded', result)
      })
      return promise
    },
    loadGenres (context: any) {
      if(context.state.isLoadingGenres) { return }

      context.commit('genreLoading')

      const promise = Server.getGenres({pageIndex: 1, pageSize: 100})
      promise.then((response: any) => {
        let result = response.body.result.items
        result.forEach((item: any) => {
          item.products = []
          item.totalProductsCount = -1
        })
        context.commit('genresLoaded', result)
      })
      return promise
    },
    loadCollection (context: any, id: number) {
      if (context.state.collections.filter((c: any) => c.id == id).length > 0) { return }

      const promise = Server.getCollection({ id: id })
      promise.then((response: any) => {
        let collection = response.body.result
        collection.totalProductsCount = -1
        collection.products = []

        context.commit('collectionLoaded', collection)
        context.dispatch('loadCollectionProducts', id)
      })

      return promise
    },
    loadGenre (context: any, id: number) {
      if (context.state.genres.filter((c: any) => c.id == id).length > 0) { return }

      const promise = Server.getGenre({ id: id })
      promise.then((response: any) => {
        let genre = response.body.result
        genre.totalProductsCount = -1
        genre.products = []

        context.commit('genreLoaded', genre)
        context.dispatch('loadGenreProducts', id)
      })

      return promise
    },
    loadCollectionProducts (context: any, id: number) {
      let collections = context.state.collections.filter(
        (c: any) => c.id === id
      )
      if (collections.length === 0) return
      let collection = collections[0]
      if (collection.totalProductsCount === collection.products.length) return

      let skipCount = collection.products.length
      const promise = Server.getProducts({
        skipCount: skipCount,
        resultCount: 15,
        collections: id
      })
      promise.then((response: any) => {
        let products = response.body.result.items
        products.forEach((product: any) => {
          if (!product.icon) {
            product.icon = context.rootGetters['tenantDesign/config'].general.defaultIcon
              ? context.rootGetters['tenantDesign/config'].general.defaultIcon : '/img/default-icon.png'
          }
        })
        let totalCount = response.body.result.total
        context.commit('collectionProductsReceived', {
          collectionId: id,
          products: products,
          totalCount: totalCount
        })
      })
      return promise
    },
    loadGenreProducts (context: any, id: number) {
      let genres = context.state.genres.filter(
        (c: any) => c.id === id
      )
      if (genres.length === 0) return
      let genre = genres[0]
      if (genre.totalProductsCount === genre.products.length) return

      let skipCount = genre.products.length
      const promise = Server.getProducts({
        skipCount: skipCount,
        resultCount: 15,
        genres: id
      })
      promise.then((response: any) => {
        let products = response.body.result.items
        products.forEach((product: any) => {
          if (!product.icon) {
            product.icon = context.rootGetters['tenantDesign/config'].general.defaultIcon
              ? context.rootGetters['tenantDesign/config'].general.defaultIcon : '/img/default-icon.png'
          }
        })
        let totalCount = response.body.result.total
        context.commit('genreProductsReceived', {
          genreId: id,
          products: products,
          totalCount: totalCount
        })
      })
      return promise
    },
    loadProduct (context: any, id: number) {
      if (context.state.productDetails.some((p: any) => p.id === id)) { return }

      const promise = Server.getProduct({ id: id })
      promise.then((response: any) => {
        let result = response.body.result
        if (!result.banner) {
          result.banner = context.rootGetters['tenantDesign/config'].general.defaultBanner
            ? context.rootGetters['tenantDesign/config'].general.defaultBanner : '/img/default-banner.jpg'
        }
        if (!result.icon) {
          result.icon = context.rootGetters['tenantDesign/config'].general.defaultIcon
            ? context.rootGetters['tenantDesign/config'].general.defaultIcon : '/img/default-icon.png'
        }

        context.commit('productDetailReceived', result)
      })

      return promise
    },
    getDownloadToken (context: any, payload: any) {
      const promise = Server.getDownloadToken({ uniqueFileName: payload.url, productId: payload.productId, tenantId: payload.tenantId })
      promise.then((response: any) => {
        // Do nothing
      })

      return promise
    },
    downloadByTicket (context: any, ticket: string) {
      const promise = Server.downloadByTicket({ ticket: ticket })
      promise.then((response: any) => {
        // Do nothing
      })

      return promise
    },
    search (context: any) {
      // Currently this method does not search and just load product summaries
      let skipCount = context.state.searchProductResults.length
      const promise = Server.getProducts({
        skipCount: skipCount,
        resultCount: 15
      })
      promise.then((response: any) => {
        let products = response.body.result.items
        products.forEach((product: any) => {
          if (!product.icon) {
            product.icon = context.rootGetters['tenantDesign/config'].general.defaultIcon
              ? context.rootGetters['tenantDesign/config'].general.defaultIcon : '/img/default-icon.png'
          }
        })
        context.commit('searchResultsReceived', products)
      })
      return promise
    },
    getProductUrl (context: any, id: number) {
      const promise = Server.getProductUrl({ id: id })
      return promise
    },
    loadAllCollections (context: any) {
      return Server.getCollections({ pageIndex: 1, pageCount: 100 })
    }
  },
  mutations: {
    slidersLoaded (state: any, value: any) {
      state.sliders = value
    },
    collectionLoading (state: any) {
      state.isLoadingCollections = true
    },
    genreLoading (state: any) {
      state.isLoadingGenres = true
    },
    collectionLoaded (state: any, value: any) {
      let filterResult = state.collections.filter(
        (p: any) => p.id == value.id
      )
      if (filterResult.length == 0) {
        state.collections.push(value)
      }

      state.isLoadingCollections = false
    },
    genreLoaded (state: any, value: any) {
      let filterResult = state.genres.filter(
        (p: any) => p.id == value.id
      )
      if (filterResult.length == 0) {
        state.genres.push(value)
      }

      state.isLoadingGenres = false
    },
    collectionsLoaded (state: any, collections: Array<any>) {
      collections.forEach(collection => {
        let filterResult = state.collections.filter(
          (p: any) => p.id == collection.id
        )
        if (filterResult.length == 0) {
          state.collections.push(collection)
        }
      })
    },
    genresLoaded (state: any, genres: Array<any>) {
      genres.forEach(genre => {
        let filterResult = state.genres.filter(
          (p: any) => p.id == genre.id
        )
        if (filterResult.length == 0) {
          state.genres.push(genre)
        }
      })
    },
    collectionProductsReceived (state: any, payload: any) {
      let collection = state.collections.filter(
        (c: any) => c.id === payload.collectionId
      )[0]
      payload.products.forEach((product: any) => {
        if (
          !collection.products.some((p: any) => {
            return p.id === product.id
          })) { collection.products.push(product) }
      })
      collection.totalProductsCount = payload.totalCount
    },
    genreProductsReceived (state: any, payload: any) {
      let genre = state.genres.filter(
        (c: any) => c.id === payload.genreId
      )[0]
      payload.products.forEach((product: any) => {
        if (
          !genre.products.some((p: any) => {
            return p.id === product.id
          })) { genre.products.push(product) }
      })
      genre.totalProductsCount = payload.totalCount
    },
    searchResultsReceived (state: any, payload: Array<any>) {
      payload.forEach((product: any) => {
        if (!state.searchProductResults.some((p: any) => { return p.id === product.id })) {
          state.searchProductResults.push(product)
        }
      })
    },
    productDetailReceived (state: any, payload: any) {
      if (!state.productDetails.some((p: any) => p.id === payload.id)) {
        state.productDetails.push(payload)
      }
    }
  }
}
